import { slugToUuid, uuidToSlug } from '#pplx/frontend/apps/ask/permalink-slug/permalinkSlug.js';
import { routes } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { toPublicWebUrl } from '#pplx/frontend/common/location.js';
const SKILLS_PATH = '/computer/skills';
export function getSkillShareURL(skillId) {
    return toPublicWebUrl(`${SKILLS_PATH}/${uuidToSlug(skillId)}`);
}
export function getProjectAccessPath(projectId) {
    return `${routes['/projects/:slug'].href({ path: { slug: projectId } })}?action=share`;
}
export function getProjectSkillShareURL(projectId, skillId) {
    const url = new URL(toPublicWebUrl(routes['/projects/:slug'].href({ path: { slug: projectId } })));
    url.searchParams.set('tab', 'settings');
    url.searchParams.set('settingsPage', 'skills');
    url.searchParams.set('skill', skillId);
    return url.toString();
}
export function getGlobalSkillShareURL(skillName, skillId) {
    const url = new URL(toPublicWebUrl(`${SKILLS_PATH}/${encodeURIComponent(skillName)}`));
    url.searchParams.set('skillId', skillId);
    return url.toString();
}
/**
 * Resolve the skill a `/computer/skills/<slug>` link denotes. Global skills use their name as the
 * slug and carry their id in `?skillId=`; older links carry a base64 uuid slug and no query param.
 *
 * A name is only rejected as an encoded uuid when it round-trips through `uuidToSlug`. Plain
 * `slugToUuid` is not a safe test: any 22-character base64-safe name decodes to 16 bytes, so
 * `quarterly-report-maker` would silently resolve to a garbage uuid instead of to itself.
 */
export function getSkillIdFromShareSlug(slug, explicitSkillId) {
    const explicit = explicitSkillId?.trim();
    if (explicit)
        return explicit;
    const decoded = slugToUuid(slug);
    return decoded && uuidToSlug(decoded) === slug ? decoded : slug;
}
//# sourceMappingURL=getSkillShareURL.js.map